import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class ProductIngredientsCarouselEnhanced {
    constructor(element) {
        if (!element) return;

        this.element = element;
        this.context = this.element.closest('.js-pdp-ingredients-carousel-enhanced-context');
        this.scrollbarElement = this.context.querySelector('.js-pdp-ingredients-carousel-enhanced-scrollbar');
        this.nextElement = this.context.querySelector('.swiper-button-next');
        this.prevElement = this.context.querySelector('.swiper-button-prev');
        this.largeBreakpont = 1024;
        this.swiper = null;

        this.init();
    }

    init() {
        this.swiper = new Swiper(this.element, {
            slidesPerView: 1.15,
            threshold: 10,
            spaceBetween: 16,
            watchOverflow: true,
            navigation: {
                nextEl: this.nextElement,
                prevEl: this.prevElement
            },
            scrollbar: {
                el: this.scrollbarElement,
                draggable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 3
                },
                1024: {
                    slidesPerView: 2.3
                }
            }
        });
    }
}
